// Function to check if an element's aria-labelledby contains size-related text
function isSizeRelatedElement(element) {
  const ariaLabelledBy = element.getAttribute('aria-labelledby');
  if (!ariaLabelledBy) return false;

  // Check if aria-labelledby contains "US Size", "UK Size", or "Euro Size"
  return (
    ariaLabelledBy.includes('US Size') ||
    ariaLabelledBy.includes('UK Size') ||
    ariaLabelledBy.includes('Euro Size')
  );
}

// Function to initialize the scroll functionality
function initializeInfiniteOptionsScroll() {
  // Find all Infinite Options ring size selectors
  const infiniteOptionsContainers = document.querySelectorAll(
    '#infiniteoptions-container'
  );

  infiniteOptionsContainers.forEach((container, index) => {
    // Check if this entire container has any dropdown/select elements
    const containerHasDropdown = container.querySelector(
      '.spb-select, select, .select, [role="combobox"]'
    );

    // If the container has a dropdown, don't add arrows to any role group
    if (containerHasDropdown) {
      return; // Skip this entire container if it contains dropdown
    }

    // Find all div[role="group"] elements that ARE size-related (US Size/UK Size/Euro Size)
    const roleGroups = container.querySelectorAll('div[role="group"]');

    if (roleGroups.length > 0) {
      roleGroups.forEach((group, groupIndex) => {
        // Only process if this group IS size-related
        if (!isSizeRelatedElement(group)) {
          return;
        }

        // Find span elements inside each role group
        const spansInGroup = group.querySelectorAll('span');

        spansInGroup.forEach((span, spanIndex) => {
          // Check if this span has labels and needs scrolling
          const hasLabels = span.querySelector('label');

          // Check if this specific span contains a dropdown/select element
          const spanHasDropdown = span.querySelector(
            '.spb-select, select, .select, [role="combobox"]'
          );

          // Only add arrows if there are labels AND no dropdown/select elements in this specific span
          if (hasLabels && !spanHasDropdown) {
            const Arrow = `
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                <path d="M12.1507 7.48553L4.87796 0.212997C4.59398 -0.0710274 4.13347 -0.0710274 3.84945 0.213045C3.56547 0.49707 3.56547 0.95753 3.8495 1.24155L10.6079 7.99986L3.84945 14.7585C3.56547 15.0425 3.56547 15.503 3.8495 15.787C3.99146 15.929 4.1776 16 4.36373 16C4.54986 16 4.736 15.929 4.87801 15.787L12.1507 8.51404C12.2871 8.37765 12.3637 8.19268 12.3637 7.99981C12.3637 7.80694 12.2871 7.62192 12.1507 7.48553Z" fill="#222222"/>
              </svg>
            `;

            // Create left arrow div
            const leftArrow = document.createElement('div');
            leftArrow.className = 'infinite-options-arrow left-arrow';
            leftArrow.innerHTML = Arrow;

            // Create right arrow div
            const rightArrow = document.createElement('div');
            rightArrow.className = 'infinite-options-arrow right-arrow';
            rightArrow.innerHTML = Arrow;

            // Insert arrows into the span
            span.insertBefore(leftArrow, span.firstChild);
            span.appendChild(rightArrow);

            // Add click event listeners to the arrows using smooth scroll
            leftArrow.addEventListener('click', function () {
              span.scrollBy({
                left: -100,
                behavior: 'smooth',
              });
            });

            rightArrow.addEventListener('click', function () {
              span.scrollBy({
                left: 100,
                behavior: 'smooth',
              });
            });

            // Add CSS styles for the arrows
            const style = document.createElement('style');
            style.textContent = `
              .infinite-options-arrow {
                position: absolute;
                width: 24px;
                height: 24px;
                display: flex;
                align-items: center;
                justify-content: center;
                top: 50%;
                cursor: pointer;
                z-index: 10;
                transition: transform 0.15s ease-in-out;
              }
              
              .infinite-options-arrow:hover {
                transform: scale(1.1);
              }
              
              .infinite-options-arrow.left-arrow {
                left: 8px;
                transform: translateY(-75%) rotate(180deg);
                margin-left: -12px;
              }
              
              .infinite-options-arrow.left-arrow:hover {
                transform: translateY(-75%) rotate(180deg) scale(1.1);
              }
              
              .infinite-options-arrow.right-arrow {
                right: 8px;
                transform: translateY(-75%);
                margin-right: -12px;
              }
              
              .infinite-options-arrow.right-arrow:hover {
                transform: translateY(-75%) scale(1.1);
              }
              
              .infinite-options-arrow svg {
                width: 16px;
                height: 16px;
              }
            `;

            // Add styles to head if not already added
            if (!document.querySelector('#infinite-options-arrow-styles')) {
              style.id = 'infinite-options-arrow-styles';
              document.head.appendChild(style);
            }
          }
        });
      });
    }
  });
}

// Wait for DOM to be ready
document.addEventListener('DOMContentLoaded', function () {
  // Try to initialize immediately
  initializeInfiniteOptionsScroll();

  // Also set up a MutationObserver to watch for dynamic content
  const targetNode = document.body;
  const config = { childList: true, subtree: true };

  const callback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        // Check if Infinite Options content was added
        const infiniteOptionsContainer = document.querySelector(
          '#infiniteoptions-container'
        );
        if (
          infiniteOptionsContainer &&
          infiniteOptionsContainer.children.length > 0
        ) {
          // Small delay to ensure content is fully rendered
          setTimeout(initializeInfiniteOptionsScroll, 100);
          observer.disconnect(); // Stop observing once we find the content
          break;
        }
      }
    }
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);

  function removeTooltipTitle() {
    const tooltipElement = document.querySelector(
      'div.spb-productdescfont.spb-productdesctextcolor.spb-tooltip'
    );
    if (tooltipElement) {
      tooltipElement.removeAttribute('title');
      return true;
    }
    return false;
  }

  if (!removeTooltipTitle()) {
    const tooltipObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          if (removeTooltipTitle()) {
            tooltipObserver.disconnect();
          }
        }
      });
    });

    tooltipObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['title'],
    });

    setTimeout(function () {
      tooltipObserver.disconnect();
    }, 10000);
  }
});
